@let d = data();
<app-card>
  <h2>{{ d.title }}</h2>
  <p>{{ d.subtitle }}</p>
  <div class="content">
    @if (d.rating !== undefined) {
      <app-response-score [score]="d.rating" />
    }
    <div>
      <div class="count">{{ d.count }}</div>
      <div class="count-title">{{ d.countTitle }}</div>
      <div class="count-subtitle">{{ d.countSubtitle }}</div>
    </div>
  </div>
  <div class="actions">
    @if (d.link) {
      <app-link [routerLink]="d.link">{{ d.linkLabel }}</app-link>
    }
  </div>
</app-card>
